import React from 'react';
import i18n from 'i18n-react';

import { ContentHeader, Toolbox, BackButton } from 'C4';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

const ToolboxView = (props) => {
  const { match: { params } } = props;
  return (
    <div className="contentContainer">
      <BackButton to="/main/" />
      <ContentHeader
        header={i18n.translate('nav.sell')}
        subtitle={i18n.translate('pageDescriptions.sell')}
      />
      <div className="filter">
        <div className="title">Filter by brand:</div>
      </div>
      <Toolbox brand={params.brand} />
    </div>
  );
};

export default ToolboxView;

ToolboxView.propTypes = {
  match: PropTypes.shape().isRequired,
};
